import React, { createContext, useContext, useMemo } from 'react';

const FormFieldsContext = createContext({ allFieldKeys: [] });

export function FormFieldsProvider({ allFieldKeys, children }) {
  const value = useMemo(() => ({ allFieldKeys: allFieldKeys || [] }), [allFieldKeys]);
  return <FormFieldsContext.Provider value={value}>{children}</FormFieldsContext.Provider>;
}

export function useAllFieldKeys() {
  const ctx = useContext(FormFieldsContext);
  return ctx.allFieldKeys;
}
